import { useState, useEffect } from 'react';
import { Box, Button, useTheme, TextField } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import Header from "../../components/Header";
import { tokens } from "../../theme";
import Modal from '@mui/material/Modal';
import ModalCharge from "../../modal/modalCharge";
import { toast } from "react-toastify";
import { useContext } from 'react';
import { FeriadosContext } from '../../context/FeriadosContext';


// Configurar dayjs para usar español
dayjs.locale('es');

const Feriados = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [openModal, setOpenModal] = useState(false);
  const [descripcion, setDescripcion] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { feriados, agregarFeriado, actualizarFeriado } = useContext(FeriadosContext);

  useEffect(() => {
    // Aquí puedes cargar los feriados guardados cuando el componente se monte
    // const cargarFeriados = async () => {
    //   try {
    //     const feriadosData = await getFeriados();
    //     setFeriados(feriadosData);
    //   } catch (error) {
    //     console.error("Error al cargar feriados:", error);
    //   }
    // };
    // cargarFeriados();
  }, []);

  // Función para manejar el registro de un nuevo feriado
  const handleRegistrarFeriado = async () => {
    if (!selectedDate || !descripcion) {
      toast.error("Por favor seleccione una fecha y agregue una descripción");
      return;
    }

    setIsLoading(true);
    try {
      const fechaFeriado = selectedDate.format('YYYY-MM-DD');
      const nuevoFeriado = {
        fecha: fechaFeriado,
        descripcion: descripcion
      };

    await agregarFeriado(nuevoFeriado);
      toast.success("Feriado registrado exitosamente");
      setOpenModal(false);
      setDescripcion("");
      setSelectedDate(null);
    } catch (error) {
      toast.error("Error al registrar el feriado");
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };


    const handleActualizarFeriado = async (id, feriado) => {
    try {
      await actualizarFeriado(id, feriado);
      toast.success("Feriado eliminado exitosamente");
    } catch (error) {
      toast.error("Error al eliminar el feriado");
      console.error("Error:", error);
    }
  };


  // Función para verificar si una fecha es feriado
  const esFeriado = (date) => {
    return feriados.some(feriado => 
      dayjs(feriado.fecha).format('YYYY-MM-DD') === date.format('YYYY-MM-DD')
    );
  };

  return (
    <Box m="20px">
      <ModalCharge open={isLoading} />
      
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="FERIADOS" subtitle="Gestión de días feriados" />
      </Box>

      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="140px"
        gap="20px"
      >
        {/* Calendario */}
        <Box
          gridColumn="span 6"
          backgroundColor={colors.primary[400]}
          p="30px"
          borderRadius="8px"
          sx={{
            height: 'fit-content',
            '& .MuiPickersDay-root.Mui-selected': {
              backgroundColor: colors.greenAccent[500],
            },
            '& .Mui-selected': {
              backgroundColor: `${colors.greenAccent[500]} !important`,
            },
            '& .feriado': {
              backgroundColor: '#ff4444',
              color: 'white',
              '&:hover': {
                backgroundColor: '#cc0000',
              },
            },
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
            <DateCalendar
              value={selectedDate}
              onChange={(newValue) => {
                setSelectedDate(newValue);
                setOpenModal(true);
              }}
              views={['day']}
              disablePast={false}
              slotProps={{
                day: (date) => {
                  const isFeriado = esFeriado(date.day);
                  return {
                    className: isFeriado ? 'feriado' : '',
                  };
                },
              }}
            />
          </LocalizationProvider>
        </Box>

        {/* Lista de Feriados */}
        <Box
          gridColumn="span 6"
          backgroundColor={colors.primary[400]}
          p="30px"
          
          borderRadius="8px"
          sx={{ height: '200px', overflowY: 'auto', maxHeight: '500px' }}
        >
          <Box display="flex" flexDirection="column" gap="10px">
            <h3 style={{ margin: '0 0 20px 0', color: colors.grey[100] }}>
              Feriados Registrados
            </h3>
            {feriados.map((feriado, index) => (
              <Box
                key={index}
                backgroundColor={colors.primary[500]}
                p="15px"
                
                borderRadius="4px"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box>
                  <p style={{ margin: '0', color: colors.grey[100] }}>
                    {dayjs(feriado.fecha).format('DD/MM/YYYY')}
                  </p>
                  <p style={{ margin: '5px 0 0 0', color: colors.grey[300] }}>
                    {feriado.descripcion}
                  </p>
                </Box>
                <Button
                  onClick={() => handleActualizarFeriado(feriado.id, { status_active: 0 })}
                  sx={{
                    backgroundColor: colors.redAccent[600],
                    color: colors.grey[100],
                    minWidth: '40px',
                    height: '40px',
                    '&:hover': {
                      backgroundColor: colors.redAccent[700],
                    },
                  }}
                >
                  X
                </Button>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      {/* Modal para registrar feriado */}
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="modal-feriado"
        aria-describedby="modal-descripcion-feriado"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: colors.primary[400],
            borderRadius: '8px',
            boxShadow: 24,
            p: 4,
          }}
        >
          <h2 style={{ color: colors.grey[100], marginTop: 0 }}>
            Registrar Feriado
          </h2>
          <Box display="flex" flexDirection="column" gap="20px">
            <TextField
              fullWidth
              label="Descripción del feriado"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              variant="filled"
              sx={{
                '& .MuiInputBase-input': {
                  color: colors.grey[100],
                },
                '& .MuiInputLabel-root': {
                  color: colors.grey[300],
                },
              }}
            />
            <Box display="flex" justifyContent="flex-end" gap="10px">
              <Button
                onClick={() => setOpenModal(false)}
                sx={{
                  backgroundColor: colors.grey[700],
                  color: colors.grey[100],
                  '&:hover': {
                    backgroundColor: colors.grey[800],
                  },
                }}
              >
                Cancelar
              </Button>
              <Button
                onClick={handleRegistrarFeriado}
                sx={{
                  backgroundColor: colors.greenAccent[600],
                  color: colors.grey[100],
                  '&:hover': {
                    backgroundColor: colors.greenAccent[700],
                  },
                }}
              >
                Registrar
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default Feriados;